import type { ProjectCommentResponseAuth } from './projectCommentResponseAuth';
import type { ProjectCommentResponseAuthor } from './projectCommentResponseAuthor';

/**
 * 프로젝트 댓글 응답 데이터
 */
export interface ProjectCommentResponse {
  /** 인증 컨텍스트 정보 */
  auth?: ProjectCommentResponseAuth;
  /** 기본 사용자 정보 */
  author: ProjectCommentResponseAuthor;
  /** 직접적인 자식 댓글(답글) 수 */
  childCount?: number;
  /** 댓글 내용 */
  content: string;
  createdAt: string;
  /** 댓글 깊이 (0부터 시작) */
  depth?: number;
  /** 댓글 ID */
  id: string;
  likeCount?: number;
  liked?: boolean;
  /**
   * 부모 댓글 ID (답글일 경우 null)
   * @nullable
   */
  parentId?: string | null;
  updatedAt?: string;
}
